module.exports = __webpack_public_path__ + "static/media/Cats eyes 02_SVENSKA-mixdown.6ad9b1ef.mp3";